import { useState } from "react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Get, Set } from "../../../../../Request";

export const useOrderDetails = (role = false) => {
  const { user } = useSelector(state => state);
  const [loading, setLoading] = useState({ details: true });
  const [details, setDetails] = useState({});
  const { trackingcodeorder } = useParams();
  const [modal, setModal] = useState({ visible: false });
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selected, setSelected] = useState([]);
  const [form, setForm] = useState({});
  const navigate = useNavigate();

  const renderRoute = () => {
    switch (role || user.role) {
      case "owner":
      case "supporter":
      case "financial":
      case "contentmaker":
        return {
          route: "/order/admin_order_details",
        };
      case "manager":
        return {
          route: "/order/manager_order_details",
        };
      case "classmanager":
        return {
          route: "/order/classmanager_order_details",
        };
      case "user":
        return {
          route: "/order/user_order_details",
        };
      default:
        break;
    }
  };
  const getOrderDetails = async () => {
    setLoading({ details: true });
    await Get({
      url: renderRoute()["route"],
      data: { trackingcodeorder },
    }).then(data => {
      setDetails(data);
      setLoading({ details: false });
    });
  };
  const isAbsent = () => {
    if (details && details.product && details.product.timetable_option) {
      const {
        timetable_option: { needsession },
      } = details.product;
      if (needsession === "true" || needsession == "true") {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };
  const isOtherPeople = () => {
    if (
      role != "user" &&
      details &&
      details.otheruser &&
      Array.isArray(details.otheruser) &&
      details.otheruser.length > 0
    ) {
      return [
        ...details.otheruser.filter(ele => ele.status == "active"),
        details.user_buyer.status == "active" ? details.user_buyer : undefined,
      ].filter(Boolean);
    }
    return false;
  };
  const setExpired = async data => {
    setLoadingBtn(true);
    Set({
      url: "/order/set_experid",
      data: { ...data },
    }).then(data => {
      setLoadingBtn(false);
      setModal({ visible: false });
      getOrderDetails();
    });
  };
  const confirm = async data => {
    setLoading({ ...loading, absent: true });
    Set({
      url: "/order/confirm_pa",
      data: data,
    }).then(res => {
      setLoading({ ...loading, absent: false });
      setModal({ visible: false });
      getOrderDetails();
    });
  };
  const refundOrder = async (orederId, role, reason,wage) => {
    let refundData = { order_id: orederId };

    if (role == "admin") {
      refundData.action = "canceled";
      refundData.wage_status = wage;
      refundData.reason = reason;
    }

    Get({ url: "/order/refund", data: refundData, addRes: true }).then(data => {
      if (data.status == "Success") {
        role == "admin"
          ? toast.success("سفارش با موفقیت لغو شد")
          : toast.success("سفارش با موفقیت استرداد شد")

        navigate(-1);
      }
    });
  }

  return {
    user,
    getOrderDetails,
    details,
    loading,
    modal,
    setModal,
    isAbsent,
    isOtherPeople,
    isOtherPeople,
    setExpired,
    loadingBtn,
    selected,
    setSelected,
    confirm,
    form,
    setForm,
    refundOrder
  };
};
